import React, { useEffect, useState } from "react"
import styled from "styled-components"
import PropTypes from "prop-types"


const Announcements = ({ announcements }) => {

  // Declare State
  const [announcementNumber, setAnnouncementNumber] = useState(0);

  const nextAnnouncement = () => {
    announcementNumber !== announcements.length - 1 ? setAnnouncementNumber(announcementNumber + 1) : setAnnouncementNumber(0);
  }

  // Change announcement every 5 seconds
  useEffect(() => {
    const interval = setInterval(nextAnnouncement, 5000);
    return () => clearInterval(interval);
  }, [announcementNumber]);

  return (
    <>
      <AnnouncementBar>
        <AnnouncementTextWrapper>
          <AnnouncementText><b>Announcement:</b> {announcements[announcementNumber]}</AnnouncementText>
        </AnnouncementTextWrapper>
        <Links>
          <ul>
            <li><a href="https://parikrama.smartschoolmis.com/" target='_blank' rel="noreferrer"><Textcolor>ERP</Textcolor></a></li>
            <li><a href="https://parikramamba.smartschoolmis.com/studentinfosys/studentportal/studinfo_studlogin.aspx" target='_blank' rel="noreferrer"><Textcolor>Student Login</Textcolor></a></li>
          </ul>
        </Links>
      </AnnouncementBar>
    </>
  );
}


// Props Type
Announcements.propTypes = {
  announcements: PropTypes.array.isRequired,
};


// ********** Styled Components ********** //

const AnnouncementBar = styled.div`

  // Margin & Padding
  margin: 0;
  padding: var(--spacer-3);
  
  // Sizing
  width: 100%;

  // Flexbox
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  // Color
  background-color: var(--primaryRedHover);
  
  // Others 
  overflow: hidden;
`;


const Links = styled.div`

  flex-shrink: 0;
  
  ul {
    
    // Margin & Padding 
    margin: 0;
    padding: 0;
    
    // Others
    list-style: none;
    
    li {
      
      // Margin & Padding
      margin: 0 0 0 var(--spacer-3);
      padding: 0;
      
      // Font
      font-family: var(--bodyFont);
      font-style: normal;
      font-weight: normal;
      font-size: var(--font-3);
      line-height: 1.25;
      
      // Colors
      color: var(--textBlack);
      
      // Others
      float: left;

      a{
        text-decoration: none;
        color: var(--textBlack);

        :hover{
          text-decoration: underline;
        }
      }
    }
  }
`;

// Announcement Text Wrapper - Created on July 9, 2020
const AnnouncementTextWrapper = styled.div`
  
  // Spacing
  margin: 0;
  padding: 0;
  
  // Flexbox
  flex-shrink: 1;
  flex-grow: 1;  
  
  // Others
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Textcolor = styled.div`
  color: var(--textWhite);
`;

const AnnouncementText = styled.p`
  
  // Margin & Padding
  margin: 0;
  padding: 0;

  // Font
  font-family: var(--bodyFont);
  font-style: normal;
  font-weight: normal;
  font-size: var(--font-3);
  line-height: 1.25;
  white-space: nowrap;
  text-overflow: ellipsis;
  
  // Colors
  color: var(--textWhite);
  
  // Others
  overflow: hidden;
  
  // Bold text inside
  b {
    font-weight: normal;
  }
  
  // Large phones and below
  @media only screen and (max-width : 544px) {
    display: none;
  }
`;


export default Announcements
